import React, { useState, useEffect, useRef } from "react";
import "./pop.css";
import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

export default function CustomSearchDropdown({
  label,
  optionsData, // List of available options
  selected,
  setSelected,
  placeholder = "Search...", // Placeholder for input
  isRequired = false, // To mark the field as required
  onSearchKeyChange, // Callback to send searchKey to parent component
  onDropdownClose, // Callback to trigger API on dropdown close
  headers = [], // Array for headers
  optionFields = {}, // Fields to display in the table rows
  customwidth,
  dropdownWidth,
}) {
  const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
  const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
  const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
  const [isAllSelected, setIsAllSelected] = useState(false); // State for Select All
  const dropdownRef = useRef(null); // To detect outside clicks

  // Filter options based on search term
  useEffect(() => {
    const filtered = searchTerm
      ? optionsData.filter((option) =>
          option[optionFields.option1]
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      : optionsData;
    setFilteredOptions(filtered);
  }, [searchTerm, optionsData, optionFields]);

  // Handle selection of individual items via checkbox only
  const handleSelect = (option) => {
    if (!selected.includes(option.id)) {
      setSelected([...selected, option.id]);
    } else {
      setSelected(selected.filter((id) => id !== option.id));
    }
  };

  // Handle 'Select All' functionality
  const handleSelectAll = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    if (!isAllSelected) {
      const allIds = filteredOptions.map((option) => option.id);
      setSelected(allIds); // Select all filtered options
    } else {
      setSelected([]); // Deselect all options
    }
    setIsAllSelected(!isAllSelected); // Toggle Select All state
  };

  // Close dropdown on outside click and trigger API call
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false); // Close dropdown when clicking outside
        if (onSearchKeyChange) {
          onSearchKeyChange(searchTerm); // Update search key
        }
        if (onDropdownClose) {
          onDropdownClose(); // Trigger API call after dropdown closes
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchTerm, onSearchKeyChange, onDropdownClose]);

  // Function to display selected options in "option1, option2, option3" format
  const getSelectedOptionsDisplay = () => {
    const selectedOptions = optionsData.filter((option) =>
      selected.includes(option.id)
    );
    return selectedOptions
      .map((option) => option[optionFields.option1]) // Show option1 field as comma-separated string
      .join(", ");
  };

  return (
    <div className="custom-dropdown-container-FC">
      <label className="dropdown-label-FC">{label}</label>

      <div className="dropdown-btn-FC" style={{ width: dropdownWidth }}>
        <input
          type="text"
          value={selected.length > 0 ? getSelectedOptionsDisplay() : searchTerm} // Display selected options in the input
          onChange={(e) => setSearchTerm(e.target.value)} // Update search term based on user input
          placeholder={placeholder} // Placeholder when no selection
          onClick={() => setIsActive(true)} // Open dropdown when typing
          className="dropdown-input-FC"
          style={{color: "#6A6A6A"}}
        />
        <img
          src={SearchIcon}
          onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
          style={{ width: "20px"}}
          alt="Search"
        />
      </div>

      {isActive && (
        <div
          className="dropdown-content-FC"
          style={{ width: customwidth }}
          ref={dropdownRef}
        >
          {/* Select All Checkbox */}
          <div className="select-all-container-FC" style={{ padding: "4px" }}>
            <input
              type="checkbox"
              checked={
                isAllSelected ||
                (selected.length === filteredOptions.length &&
                  selected.length > 0)
              }
              onChange={handleSelectAll} // Select or Deselect all
            />
            <label style={{ marginLeft: "8px" }}>Select All</label>
          </div>

          {/* Render filtered options in a table */}
          {filteredOptions.length > 0 ? (
            <table id="customers">
              <thead>
                <tr>
                  <th></th>
                  {headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredOptions.map((option) => (
                  <tr
                    key={option.id}
                    className={selected.includes(option.id) ? "selected" : ""}
                    style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(option.id)}
                        onChange={() => handleSelect(option)} // Only change via checkbox
                      />
                    </td>
                    <td>{option[optionFields.option1]}</td>
                    <td>{option[optionFields.option2]}</td>
                    <td>{option[optionFields.option3]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="dropdown-no-options-FC">No options found</div>
          )}
        </div>
      )}
    </div>
  );
}


